import { PageTitleWithMenu } from '@procureai/ui-mui';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export const InternalToolsPageTitle = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Nav' });
  const title = t(`internalTools`);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageTitleWithMenu title={title} disabled />
    </>
  );
};
